class KodaCollectionCard extends HTMLElement {
  #resizeObserver;

  connectedCallback() {
    this.#setActiveImage(0, false);
    this.addEventListener('click', this.#handleClick);

    this.#resizeObserver = new ResizeObserver(() => this.#updateThumbnailOverflow());
    this.#resizeObserver.observe(this);
    requestAnimationFrame(() => this.#updateThumbnailOverflow());
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick);
    this.#resizeObserver?.disconnect();
  }

  #handleClick = (event) => {
    const thumbnail = event.target.closest('[data-gallery-thumbnail]');
    if (!(thumbnail instanceof HTMLButtonElement) || !this.contains(thumbnail)) return;

    event.preventDefault();
    this.#setActiveImage(Number(thumbnail.dataset.galleryThumbnail), true);
  };

  #setActiveImage(index, isManualSelection) {
    const images = [...this.querySelectorAll('.koda-collection-card__image')];
    if (!images[index]) return;

    this.dataset.galleryActiveIndex = String(index);
    if (isManualSelection) this.dataset.galleryActive = 'true';

    images.forEach((image, imageIndex) => {
      image.setAttribute('aria-hidden', imageIndex === index ? 'false' : 'true');
    });

    this.querySelectorAll('[data-gallery-thumbnail]').forEach((thumbnail) => {
      thumbnail.setAttribute('aria-pressed', thumbnail.dataset.galleryThumbnail === String(index) ? 'true' : 'false');
    });
  }

  #updateThumbnailOverflow() {
    const list = this.querySelector('[data-collection-thumbnail-list]');
    const more = this.querySelector('[data-gallery-more]');
    if (!(list instanceof HTMLElement) || !(more instanceof HTMLElement)) return;

    const thumbnails = [...list.querySelectorAll('[data-gallery-thumbnail]')];
    if (!thumbnails.length) return;

    more.hidden = false;
    const listRight = list.getBoundingClientRect().right;
    const visibleCount = Math.min(
      4,
      Math.max(1, thumbnails.filter((thumbnail) => thumbnail.getBoundingClientRect().right <= listRight + 0.5).length)
    );
    const totalCount = Number(this.dataset.thumbnailTotal) || thumbnails.length;
    const hiddenCount = Math.max(0, totalCount - visibleCount);

    thumbnails.forEach((thumbnail, index) => {
      thumbnail.hidden = index >= visibleCount;
    });

    more.hidden = hiddenCount === 0;
    if (hiddenCount > 0) {
      more.textContent = `+${hiddenCount}`;
      more.setAttribute('aria-label', `View ${hiddenCount} more product images`);
    }
  }
}

if (!customElements.get('koda-collection-card')) {
  customElements.define('koda-collection-card', KodaCollectionCard);
}
